import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CbButtonModule, CbIconModule, CbIconSize, CbModalModule } from '@chubb/ui-components';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../shared/services/auth.service';
import { GlobalErrorHandler } from '../../../shared/services/error-handler.service';

@Component({
  selector: 'app-classic-layout-nz',
  templateUrl: './classic-layout-nz.component.html',
  styleUrls: ['./classic-layout-nz.component.scss'],
  imports: [RouterOutlet, CbIconModule, CbModalModule, CbButtonModule],
})
export class ClassicLayoutNzComponent implements OnInit {
  userinfo: string = '';
  openErrorModal: boolean = false;
  errorMessage: string =
    'Something went wrong. Please refresh the page. If the issue persists please call the Chubb Life team on 0508 464 999 for assistance.';

  _errorModalSubscription: Subscription = new Subscription();
  _errorMessageSubscription: Subscription = new Subscription();
  protected readonly _globalErrorHandler: GlobalErrorHandler = inject(GlobalErrorHandler);
  protected readonly _oauthService = inject(AuthService);

  // Enum of icon size
  CbIconSize = CbIconSize;

  ngOnInit() {
    this._errorModalSubscription = this._globalErrorHandler.displayError$.subscribe(show => {
      this.openErrorModal = show;
    });
    this._errorMessageSubscription = this._globalErrorHandler.displayErrorMessage$.subscribe(message => {
      this.errorMessage =
        message ??
        'Something went wrong. Please refresh the page. If the issue persists please call the Chubb Life team on 0508 464 999 for assistance.';
    });
  }

  ngDoCheck() {
    this.userinfo = sessionStorage.getItem('username') ?? '';
  }

  ngOnDestroy() {
    if (this._errorModalSubscription) {
      this._errorModalSubscription.unsubscribe();
    }
    if (this._errorMessageSubscription) {
      this._errorMessageSubscription.unsubscribe();
    }
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  hideError() {
    this._globalErrorHandler.hideError();
  }
}
